import { render } from "./suggestive-search.vue?vue&type=template&id=5818ac9a"
import script from "./suggestive-search.vue?vue&type=script&lang=js"
export * from "./suggestive-search.vue?vue&type=script&lang=js"

import exportComponent from "/Users/drewcarrette/Sites/connected-medical/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__